//#region Libraries
//#endregion
//#region Styles
import { TitleSection } from "components/styles";
import { Container } from "./styles";
//#endregion
//#region Components
import CloseButton from "components/CloseButton/CloseButton";
import DialogAlert from "components/DialogAlert/DialogAlert";
import HistoryTable from "../HistoryTable/HistoryTable";
//#endregion
//#region Images
//#endregion
//#region Services
//#endregion
//#region Utils
//#endregion

const DialogChangeHistory = ({
    show,
    toggleShow,
    changeHistory
}) => {
    return (
        <DialogAlert 
            show={show} 
            toggleShow={toggleShow}
            close={() => toggleShow(false)}>
            <CloseButton onClick={() => toggleShow(false)}/>
            <Container>
                <TitleSection 
                    fontWeight="900"
                    textAlign="center">Historial de cambios</TitleSection>
                <HistoryTable changeHistory={changeHistory}/>
            </Container>
        </DialogAlert>
    );
}

export default DialogChangeHistory;